module.exports = __webpack_public_path__ + "assets/img/69_316_4.c27ace46.jpg";